import React, { Component } from "react";
import { find, sumBy } from "lodash";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { formatNumberOnDashBoard } from "../../../../helper";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { PATHS } from "../../../../constant";

export default class ChartsDetails extends Component {
  state = {
    updateValues: 0
  };

  componentDidMount() {
    window && window.addEventListener("scroll", this.onScroll);
  }

  onScroll = () => {
    let currentOffset = (window && window.scrollY) || 0;
    if (
      (currentOffset > 520 && currentOffset < 600) ||
      (currentOffset > 800 && currentOffset < 900) ||
      (currentOffset > 1200 && currentOffset < 1350)
    ) {
      this.setState({
        updateValues: Math.random()
      });
    }
  };

  render() {
    const { data, isDesktopView, checkedValue } = this.props;
    let { updateValues } = this.state;

    let commissionedObj = find(data, ["name", "COMMISSIONED"]);
    let UnderConstructionObj = find(data, [
      "name",
      "UNDER CONSTRUCTION / UNDER IMPLEMENTATION"
    ]);

    let settings = {
      dots: true,
      infinite: true,
      //speed: 100,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
      //autoplay:false,
      // autoplaySpeed:3000
    };

    let test = (
      <React.Fragment>
        <Link
          className="status-box detail-box"
          to={{
            pathname: PATHS.PROJECT_LIST,
            isDashBoard: true,
            state: {
              projectTags: [
                { key: "COMMISSIONED", displayName: "Commissioned" }
              ],
              projectFlags: checkedValue
                ? [
                    {
                      displayName: "MARCH 24",
                      key: "MARCH 24"
                    }
                  ]
                : null,
              groupCategory: "CENTRAL"
            }
          }}
        >
          <div className="padding-zero">
            <div className="top-section">Status Breakup</div>
            <div className="middle-section">
              {sumBy(data, "count") ? (
                <CountUp
                  start={updateValues}
                  end={sumBy(data, "count")}
                  delay={0}
                  duration={2.75}
                >
                  {({ countUpRef }) => (
                    <div>
                      <span ref={countUpRef} />
                    </div>
                  )}
                </CountUp>
              ) : (
                0
              )}
              Total Projects
            </div>
            <div className="last-section">
              <div>
                {commissionedObj && commissionedObj.count ? (
                  <CountUp
                    start={updateValues}
                    end={commissionedObj && commissionedObj.count}
                    delay={0}
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <div>
                        <span ref={countUpRef} />
                      </div>
                    )}
                  </CountUp>
                ) : (
                  0
                )}
                Commissioned
              </div>
              <div>
                {UnderConstructionObj && UnderConstructionObj.count ? (
                  <CountUp
                    start={updateValues}
                    end={UnderConstructionObj && UnderConstructionObj.count}
                    delay={0}
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <div>
                        <span ref={countUpRef} />
                      </div>
                    )}
                  </CountUp>
                ) : (
                  0
                )}
                Under Construction
              </div>
            </div>
          </div>
        </Link>

        <div className="detail-box investment-box">
          <div className="top-section">Investment Breakup</div>
          <div className="middle-section">
            {sumBy(data, "cost") && (
              <CountUp
                start={updateValues}
                end={sumBy(data, "cost")}
                delay={0}
                useEasing={true}
                formattingFn={n =>
                  formatNumberOnDashBoard(Number(n.toFixed(1)), true, true, ".")
                }
                duration={2.75}
              >
                {({ countUpRef }) => (
                  <div>
                    <span ref={countUpRef} />
                  </div>
                )}
              </CountUp>
            )}
            Anticipated Investments
          </div>
          <div className="last-section">
            <div>
              {commissionedObj && (
                <CountUp
                  start={updateValues}
                  end={commissionedObj.cost}
                  delay={0}
                  useEasing={true}
                  formattingFn={n =>
                    formatNumberOnDashBoard(
                      Number(n.toFixed(1)),
                      true,
                      true,
                      "."
                    )
                  }
                  duration={2.75}
                >
                  {({ countUpRef }) => (
                    <div>
                      <span ref={countUpRef} />
                    </div>
                  )}
                </CountUp>
              )}
              Commissioned
            </div>
            <div>
              {UnderConstructionObj && (
                <CountUp
                  start={updateValues}
                  end={UnderConstructionObj.cost}
                  delay={0}
                  useEasing={true}
                  formattingFn={n =>
                    formatNumberOnDashBoard(
                      Number(n.toFixed(1)),
                      true,
                      true,
                      "."
                    )
                  }
                  duration={2.75}
                >
                  {({ countUpRef }) => (
                    <div>
                      <span ref={countUpRef} />
                    </div>
                  )}
                </CountUp>
              )}
              Under Construction
            </div>
          </div>
        </div>
      </React.Fragment>
    );

    return isDesktopView ? (
      <div className="dashboard-charts-detail-box first-page">{test}</div>
    ) : (
      <div className="dashboard-charts-detail-box first-page">
        <Slider {...settings}>
          <Link
            className="status-box detail-box"
            to={{
              pathname: PATHS.PROJECT_LIST,
              isDashBoard: true,
              state: {
                projectTags: [
                  { key: "COMMISSIONED", displayName: "Commissioned" }
                ],
                groupCategory: "CENTRAL"
              }
            }}
          >
            <div className="padding-zero">
              <div className="top-section">Status Breakup</div>
              <div className="middle-section">
                {sumBy(data, "count") ? (
                  <CountUp
                    start={updateValues}
                    end={sumBy(data, "count")}
                    delay={0}
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <div>
                        <span ref={countUpRef} />
                      </div>
                    )}
                  </CountUp>
                ) : (
                  0
                )}
                Total Projects
              </div>
              <div className="last-section">
                <div>
                  {commissionedObj && commissionedObj.count ? (
                    <CountUp
                      start={updateValues}
                      end={commissionedObj && commissionedObj.count}
                      delay={0}
                      duration={2.75}
                    >
                      {({ countUpRef }) => (
                        <div>
                          <span ref={countUpRef} />
                        </div>
                      )}
                    </CountUp>
                  ) : (
                    0
                  )}
                  Commissioned
                </div>
                <div>
                  {UnderConstructionObj && UnderConstructionObj.count ? (
                    <CountUp
                      start={updateValues}
                      end={UnderConstructionObj && UnderConstructionObj.count}
                      delay={0}
                      duration={2.75}
                    >
                      {({ countUpRef }) => (
                        <div>
                          <span ref={countUpRef} />
                        </div>
                      )}
                    </CountUp>
                  ) : (
                    0
                  )}
                  Under Construction
                </div>
              </div>
            </div>
          </Link>

          <div className="detail-box investment-box">
            <div className="top-section">Investment Breakup</div>
            <div className="middle-section">
              {sumBy(data, "cost") && (
                <CountUp
                  start={updateValues}
                  end={sumBy(data, "cost")}
                  delay={0}
                  useEasing={true}
                  formattingFn={n =>
                    formatNumberOnDashBoard(
                      Number(n.toFixed(1)),
                      true,
                      true,
                      "."
                    )
                  }
                  duration={2.75}
                >
                  {({ countUpRef }) => (
                    <div>
                      <span ref={countUpRef} />
                    </div>
                  )}
                </CountUp>
              )}
              Anticipated Investments
            </div>
            <div className="last-section">
              <div>
                {commissionedObj && (
                  <CountUp
                    start={updateValues}
                    end={commissionedObj.cost}
                    delay={0}
                    useEasing={true}
                    formattingFn={n =>
                      formatNumberOnDashBoard(
                        Number(n.toFixed(1)),
                        true,
                        true,
                        "."
                      )
                    }
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <div>
                        <span ref={countUpRef} />
                      </div>
                    )}
                  </CountUp>
                )}
                Commissioned
              </div>
              <div>
                {UnderConstructionObj && (
                  <CountUp
                    start={updateValues}
                    end={UnderConstructionObj.cost}
                    delay={0}
                    useEasing={true}
                    formattingFn={n =>
                      formatNumberOnDashBoard(
                        Number(n.toFixed(1)),
                        true,
                        true,
                        "."
                      )
                    }
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <div>
                        <span ref={countUpRef} />
                      </div>
                    )}
                  </CountUp>
                )}
                Under Construction
              </div>
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}
